import { render, staticRenderFns } from "./distcommissionpool.vue?vue&type=template&id=4158f8b8&"
import script from "./distcommissionpool.vue?vue&type=script&lang=js&"
export * from "./distcommissionpool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports